namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailSkupinaFunkci extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GSkupinaFunkciReadDto;
        private newRecord: boolean;
        private detailObj: DetailSkupinaFunkciObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailSkupinaFunkciObj());
            this.detailObj.createBase({
                contentName: "detailSkupinaFunkci",
                contentCaption: "jres:33000887",  //RC 33000887 : Skupina funkc�
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.getSkupinaFunkciClenTab());
                tabs.push(this.detailObj.getSkupinaFunkciOpravneniTab());
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.getSkupinaFunkciClenGroup());
                groups.push(this.detailObj.getSkupinaFunkciOpravneniGroup());
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailSkupinaFunkci", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailSkupinaFunkciObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GSkupinaFunkciReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return `${this.data.ixs_sfu}`;
        }

        saveData(data: Gordic.AdmIsl.Interface.GSkupinaFunkciSaveDto, close: boolean) {
            this.cnt.isl.SkupinaFunkci.upsert({ data: data }).get().done((output: any) => {
                Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderGinssfu");
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).catch((err) => {
                this.pendingAction("actSave", false)
                throw err;
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailSkupinaFunkci", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.SkupinaFunkci.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.data.nazev}`;
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                {
                    favorite: true,
                    type: "static",
                    visible: this.options.newRecord == false,
                    caption: "jres:33000138",
                    icon: "fa-link",
                    children: [
                        { action: this.cnt.actions.actOpenSkupinaFunkciClen },
                        { action: this.cnt.actions.actOpenSkupinaFunkciOpravneni }
                    ]
                },
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSkupinaFunkciClen: {
                    icon: "fa-link",
                    caption: "jres:33000889",
                    run: () => {
                        this.openSkupinaFunkciClen();
                    }
                },
                actOpenSkupinaFunkciOpravneni: {
                    icon: "fa-link",
                    caption: "jres:33000891",
                    run: () => {
                        this.openSkupinaFunkciOpravneni();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeField("ixs_sfu");
            this.MakeField("nazev")
            this.MakeField("zkratka")
            this.MakeField("poznamka")
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        getSkupinaFunkciClenTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-skupina-funkci-clenove",
                    title: "jres:33000889", //RC 33000889 : P�i�azen� funk�n� m�sta skupin�
                    opened: true,
                    locked: true,
                    group: { id: "_tab-skupina-funkci-clenove" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamSkupinaFunkciClen",
                    serverParams: {
                        ID: "SeznamSkupinaFunkciClen",
                        ixs_sfu: this.data.ixs_sfu,
                        tabOpen: true
                    }
                }
            }
        }


        getSkupinaFunkciOpravneniTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-skupina-funkci-opravneni",
                    title: "jres:33000891", //RC 33000891 : Pr�va ke skupin�
                    opened: true,
                    locked: true,
                    group: { id: "_tab-skupina-funkci-opravneni" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamSkupinaFunkciOpravneni",
                    serverParams: {
                        ID: "SeznamSkupinaFunkciOpravneni",
                        ixs_sfu: this.data.ixs_sfu,
                        tabOpen: true
                    }
                }
            }
        }

        getSkupinaFunkciClenGroup(): IGTabGroupOptions {
            return { id: "_tab-skupina-funkci-clenove", caption: "jres:33000889" }
        }

        getSkupinaFunkciOpravneniGroup(): IGTabGroupOptions {
            return { id: "_tab-skupina-funkci-opravneni", caption: "jres:33000891" }
        }

        private openSkupinaFunkciClen() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamSkupinaFunkciClen", { ixs_sfu: this.data.ixs_sfu })
        }

        private openSkupinaFunkciOpravneni() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamSkupinaFunkciOpravneni", { ixs_sfu: this.data.ixs_sfu })
        }
    }
}